import { LogSourceAction } from '../actions/logsources';
import { LogSourceList, Store } from '../types';

export type State = {
  readonly isLogSourcesLoading: boolean;
  readonly isReservedTagsLoading: boolean;
  readonly logSources: LogSourceList;
  readonly reservedTags: Array<string>;
};

export const INITIAL_LOG_SOURCES_STATE: State = {
  isLogSourcesLoading: false,
  isReservedTagsLoading: false,
  logSources: [],
  reservedTags: [],
};

const logSourceReducer = (
  state: State = INITIAL_LOG_SOURCES_STATE,
  action: LogSourceAction,
): State => {
  switch (action.type) {
    case 'set_log_sources':
      return {
        ...state,
        logSources: action.logSources,
        isLogSourcesLoading: false,
      };

    case 'set_log_sources_loading':
      return {
        ...state,
        isLogSourcesLoading: action.isLoading,
      };

    case 'set_reserved_log_tags':
      return {
        ...state,
        reservedTags: action.tags,
        isReservedTagsLoading: false,
      };

    case 'set_reserved_log_tags_loading':
      return {
        ...state,
        isReservedTagsLoading: action.isLoading,
      };

    default:
      return state;
  }
};

export default logSourceReducer;

// ------------
// Selectors
// -------------

export const logSourceSelector = {
  getLogSources: (store: Store): LogSourceList => store.logSource.logSources,
  getReservedTags: (store: Store): Array<string> =>
    store.logSource.reservedTags,
  isLogSourcesLoading: (store: Store): boolean =>
    store.logSource.isLogSourcesLoading,
  isReservedTagsLaoding: (store: Store): boolean =>
    store.logSource.isReservedTagsLoading,
};
